import { Box, Typography, styled } from "@mui/material"

export const ButtonWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing(5),
    justifyContent: "space-around",
}))

export const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(5),
    textAlign: "left",
    display: "inline-block",
    width: "100%",
}))

export const Text = styled(Title)(({ theme }) => ({
    margin: theme.spacing(0, 0, 5, 0),
    textAlign: "left",
    whiteSpace: "pre-line",
}))

export const Wrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(8),
    left: "50%",
    p: 4,
    padding: theme.spacing(7),
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: 465,
    maxWidth: "90%",
}))